import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import UnauthenticatedRoute from './UnauthenticatedRoute';
import AuthenticatedRoute from './AuthenticatedRoute';
// Auth
import LoginPage from '../features/auth/LoginPage';
import SignupPage from '../features/auth/SignupPage';
import ConfirmSignupPage from '../features/auth/ConfirmSignupPage';
import ForgotPasswordPage from '../features/auth/ForgotPasswordPage';
// Features
import FolderPage from '../features/folder/FolderPage';
import AccountPage from '../features/account/AccountPage';
import ProjectPage from '../features/project/ProjectPage';
import ResourcePage from '../features/resource/ResourcePage';
import OutsideLinkPage from '../features/sharing/OutsideLinkPage';
import GuestProjectPage from '../features/sharing/GuestProjectPage';
import WelcomePage from '../features/onboarding/WelcomePage';
import NoMatchPage from '../features/onboarding/NoMatchPage';
import FreeTrialEndedPage from '../features/onboarding/FreeTrialEndedPage';

/** Bare root: invitation links (<domain>?invid=<id>) continue to signup with the query; everything else goes to login. */
function RootRedirect() {
  const { search } = useLocation();
  const to = new URLSearchParams(search).has('invid') ? `/signup${search}` : '/login';
  return <Navigate to={to} replace />;
}

export default function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<UnauthenticatedRoute><RootRedirect /></UnauthenticatedRoute>} />
      <Route path="/login" element={<UnauthenticatedRoute><LoginPage /></UnauthenticatedRoute>} />
      <Route path="/signup" element={<UnauthenticatedRoute><SignupPage /></UnauthenticatedRoute>} />
      <Route path="/signup/:id" element={<UnauthenticatedRoute><SignupPage /></UnauthenticatedRoute>} />
      <Route path="/signup/confirm" element={<UnauthenticatedRoute><ConfirmSignupPage /></UnauthenticatedRoute>} />
      <Route path="/forgotPassword" element={<UnauthenticatedRoute><ForgotPasswordPage /></UnauthenticatedRoute>} />
      <Route path="/guest/:id" element={<UnauthenticatedRoute isGuestRoute><GuestProjectPage /></UnauthenticatedRoute>} />
      <Route path="/link/:id" element={<UnauthenticatedRoute><OutsideLinkPage /></UnauthenticatedRoute>} />

      {/* Authenticated routes */}
      <Route path="/in/account/:id" element={<AuthenticatedRoute><AccountPage /></AuthenticatedRoute>} />
      <Route path="/in/welcome" element={<AuthenticatedRoute><WelcomePage /></AuthenticatedRoute>} />
      <Route path="/in/freeTrialEnded" element={<AuthenticatedRoute><FreeTrialEndedPage /></AuthenticatedRoute>} />
      <Route path="/in/link/:id" element={<AuthenticatedRoute><OutsideLinkPage /></AuthenticatedRoute>} />
      <Route path="/in/folder/:id" element={<AuthenticatedRoute><FolderPage /></AuthenticatedRoute>} />
      <Route path="/in/folder/:parentId/resource/:id/:viewType" element={<AuthenticatedRoute><ResourcePage /></AuthenticatedRoute>} />
      <Route path="/in/project/:parentId/resource/:id/:viewType" element={<AuthenticatedRoute><ResourcePage /></AuthenticatedRoute>} />
      <Route path="/in/project/:id/:viewType" element={<AuthenticatedRoute><ProjectPage /></AuthenticatedRoute>} />
      <Route path="/in/project/:id" element={<AuthenticatedRoute><ProjectPage /></AuthenticatedRoute>} />

      {/* Catch-all */}
      <Route path="*" element={<AuthenticatedRoute><NoMatchPage /></AuthenticatedRoute>} />
    </Routes>
  );
}
